<template>
  <div class="h5_register">
      <div class="pic_box">
          <img src="../../../assets/img/h5_login.png" alt="">
      </div>
      <div class="kvbfk">
          <div class="center">{{$t('other.a406')}},{{$t('other.a394')}}</div>
          <van-tabs @change="changeItem()" v-model="activeName">
            <van-tab :title="$t('other.a460')">
                <van-dropdown-menu style="margin-top:10px">
                <van-dropdown-item v-model="value1" :options="option1" />
                </van-dropdown-menu>
                <van-field class="userAccount"  v-model="userId" :label="$t('other.a395')"  :placeholder="$t('other.a1753')"/>
                <van-field class="userAccount"  v-model="password" type="password" :label="$t('other.a464')"  :placeholder="$t('other.a1754')"/>
                <van-field class="userAccount"  v-model="emailCode" t :label="$t('other.a401')"  :placeholder="$t('other.a432')">
                <template #button>
                    <van-button size="small" type="primary" @click="sendCode()">{{$t('other.a1750')}}</van-button>
                </template>
                </van-field>
                <van-field class="userAccount"  v-model="userName"  :label="$t('other.a430')"  :placeholder="$t('other.a1755')"/>
                 <van-field class="userAccount"  v-model="invitationCode"  :label="$t('other.a434')"  :placeholder="$t('other.a1756')"/>
                <div style="text-align:center"><van-button class="btn" type="info" @click="singIn()">{{$t('other.a1751')}}</van-button></div>
            </van-tab>
            <van-tab :title="$t('other.a461')">
                <van-field class="userAccount"  v-model="userId" :label="$t('other.a1757')" :placeholder="$t('other.a1757')"/>
                <van-field class="userAccount"  v-model="password" type="password" :label="$t('other.a464')"  :placeholder="$t('other.a1754')"/>
                <van-field class="userAccount"  v-model="emailCode"  :label="$t('other.a535')"  :placeholder="$t('other.a432')" >
                <template #button>
                    <van-button size="small" type="primary" @click="sendEmailCode()">{{$t('other.a1750')}}</van-button>
                </template>
                </van-field>
                <van-field class="userAccount"  v-model="userName"  :label="$t('other.a430')"  :placeholder="$t('other.a1755')"/>
                <van-field class="userAccount"  v-model="invitationCode"  :label="$t('other.a434')"  :placeholder="$t('other.a1756')"/>
                <div style="text-align:center"><van-button class="btn" type="info" @click="singInByEmail()">{{$t('other.a1751')}}</van-button></div>
            </van-tab>
 
        </van-tabs>
      </div>
      
       <div class="registore" @click="toLogin()">{{$t('other.a1752')}}</div>
      
  </div>
</template>

<script>
import api from '../../../api/api'
import newOrderApi from '../../../api/moudles/newOrders'
import loginApi from '../../../api/moudles/login'
import md5 from 'js-md5';
import jsonp from '../../../api/jsonp';
export default {
data(){
return{
    password:null,
    userId:'',
    activeName:0,
    emailCode:null,
    invitationCode:null,
    userName:null,
    value1: '+86',
    option1:[{
        value: '+86',
        text: 'China(+86)'
    },{
        value: '+63',
        text: 'Philippines(+63)'
    }, {
        value: '+65',
        text: 'Singapore(+65)'
    }, {
        value: '+84',
        text: 'Vietnam(+84)'
    },{
        value: '+60',
        text: 'Malaysia(+60)'
    },{
        value: '+34',
        text: 'Spain(+34)'
    },{
        value: '+62',
        text: 'Indonesia(+62)'
    },{
        value: '+66',
        text: 'Thailand(+66)'
    },{
        value: '+351',
        text: 'Portugal(+Portugal)'
    }],

}
},
created(){
    this.invitationCode=this.$route.query.invitationCode
},
methods:{

    singInByEmail(){
        if(!this.userId || !this.password || !this.emailCode || !this.userName){
            this.$toast(this.$t('other.a1758'))
            return
        }    
        let params={
            emailCode:JSON.parse(JSON.stringify(this.emailCode)),
            password:md5(JSON.parse(JSON.stringify(this.password)).replace(/\s*/g,"") + 'seller'),
            userId:JSON.parse(JSON.stringify(this.userId)).replace(/\s*/g,""),
            user:{
                invitationCode:JSON.parse(JSON.stringify(this.invitationCode)),
                userPos:'SELLER',
                userName:JSON.parse(JSON.stringify(this.userName)),
                userPhone:JSON.parse(JSON.stringify(this.userId)).replace(/\s*/g,"")
            }
        }
        
        loginApi
        .getRegister(params)
        .then(res => {
        if(res.code === 200 ){
        this.$toast(this.$t('other.a1759'))
        }else{
        this.$toast(res.msg)
        }
        })
    },

    changeItem(){
        console.log(this.activeName)
        this.userId=null,
        this.password=null,
        this.userName=null,
        this.emailCode=null
    },

    sendEmailCode(){
        if(!this.userId){
            this.$toast(this.$t('other.a523'))
            return
        }

        loginApi
        .getEmailCode({
            email:this.userId,
        })
        .then(res => {
        if(res.code === 200 ){
        this.$toast(this.$t('other.a1760'))
        }else{
        this.$toast(res.msg)
        }
        })
    },
    

    sendCode(){
        if(!this.userId){
            this.$toast(this.$t('other.a1761'))
            return
        }
        newOrderApi
        .getPhoneCode({
            country:this.value1,
            phone:this.userId
        })
        .then(res => {
        if(res.code === 200 ){
        this.$toast(this.$t('other.a1760'))
        }else{
        this.$toast(res.msg)
        }
        })
    },

    singIn(){  
        if(!this.userId || !this.password || !this.emailCode || !this.userName){
            this.$toast(this.$t('other.a1758'))
            return
        }    
        let params={
            emailCode:JSON.parse(JSON.stringify(this.emailCode)),
            password:md5(JSON.parse(JSON.stringify(this.password)).replace(/\s*/g,"") + 'seller'),
            userId:JSON.parse(JSON.stringify(this.userId)).replace(/\s*/g,""),
            user:{
                invitationCode:JSON.parse(JSON.stringify(this.invitationCode)),
                userPos:'SELLER',
                userName:JSON.parse(JSON.stringify(this.userName)),
                userPhone:JSON.parse(JSON.stringify(this.userId)).replace(/\s*/g,"")
            }
        }

        console.log(params)



        newOrderApi
        .phoneRegister(params)
        .then(res => {
        if(res.code === 200 ){
        this.$toast(this.$t('other.a1759'))
        }else{
        this.$toast(res.msg)
        }
        })

       
        // let password=JSON.parse(JSON.stringify(this.password)).replace(/\s*/g,"")
        
    },

    toLogin(){
        this.$router.push({
            path:'/mh5/login',
            query:{
            invitationCode:this.$route.query.invitationCode
            }
        })
    },

}
}

</script>
<style lang="scss" scoped>

.h5_register{

    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding-bottom: 4rem;

    .userAccount{
        margin: 10px 0;
    }

    
    

    .kvbfk{
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .center{
            color: #1989fa;
            font-weight: bold;
            font-size: 25px;
            margin-bottom: 1rem;
            
        }
    }

   .pic_box{
       width: 7rem;
       height: 0;
       padding-bottom:7rem;
       overflow: hidden;
      


       img{
           width: 100%;
       }
   }


   .btn{
       width: 10rem;
       margin-top: 1rem;
   }



   .registore{
       font-size: 0.6rem;
       margin-top: 10px;
       color:#1989fa ;
   }



   /deep/ .van-tabs{
        width:80%
    }

   /deep/ .van-field__label{
       width:3.5rem;
       margin-right:0
   }

   /deep/ .van-field{
       border-bottom: 1px solid #eee;
   }

    /deep/ .van-field::after{
       border-bottom: none;
   }

}
</style>